var Backbone = require('backbone'),
    $ = require('jquery'),
    fvChannel = require('glRadio').channel('FV');

module.exports = Backbone.Model.extend({

    doubleHorPadding: 0,
    doubleVertPadding: 0,
    SB_W: 0,

    // don't need attributes / model
    defaults: {
        mode: '', //marker for which mode we it belongs to -- pg or doc ... set on into -- determine is use currentPage / fullpg model for the page var
        scale: '', //set on init
        scaleType: '', //predefined, custom, page-fit, page-width, auto,
        DEFAULT_SCALE: '', /*set from settings on init; also dependent on pgModel isImageType*/
        H_PADDING: 0,
        V_PADDING: 0,
        outerDiv: {}

    },

    initialize: function() {

        this.set({
            scaleType: this._getScaleType()
        });

        /* cache some values*/
        this.doubleHorPadding = this.get('H_PADDING') * 2;
        this.doubleVertPadding = this.get('V_PADDING') * 2;

        this.SB_W = fvChannel.request('settings').scrollBarWidth;
       
    },

    /**
     * Now all required -- pass through controller ( which is now the state -- no, not all required , init?
     * Note: for correct page calc fn's, need the page object
     * TODO: most of this just do in mediator caller (better clarity anyway)
     */

    setScale: function(page, newScale, newScaleType, options) {

        var scale = newScale ? newScale : this.get('scale'),
            scaleType = newScaleType ? newScaleType : this.get('scaleType'),

            rotatedPgDimensions = page.getRotatedDimensions(),
            pageW = rotatedPgDimensions.width,
            pageH = rotatedPgDimensions.height,

            outerWt = this.get('outerDiv').offsetWidth,
            outerHt = this.get('outerDiv').offsetHeight,

            fitWidthScale =  this.getFitWidthScale( outerWt, pageW ),
            fitHeightScale =  this.getFitHeightScale( outerHt, outerWt, pageH, pageW ),
            autoScale =  Math.min( 1.0, fitWidthScale ),
            bestFitScale =  Math.min( fitHeightScale, fitWidthScale ),

            scaleOpts = {};

            switch(scaleType) {  //the predefined types are now the actual values to print
                case 'Auto':   //the minimum of 100% scale or page width
                    scaleOpts = {
                        scale: autoScale,
                        scaleType: scaleType
                    };                  /* first 3 must match the value as defined on the HTML zoom template */
                    break;
                case 'Best Fit':
                    scaleOpts = {
                        scale: bestFitScale,
                        scaleType: scaleType
                    };
                    break;
                case 'Fit Width':
                    scaleOpts = {
                        scale: fitWidthScale,
                        scaleType: scaleType
                    };
                    break;
                case 'Fit Height':
                    scaleOpts = {
                        scale: fitHeightScale,
                        scaleType: scaleType
                    };
                    break;
                case 'Dot For Dot':
                    scaleOpts =  {
                        scale: 1.0,
                        scaleType: scaleType
                    };
                    break;
                case 'custom': //numeric and not predefined ('custom') -- from custom zoom buttons  : //ensure a number
                    scaleOpts =  {
                        scale: parseFloat(scale),
                        scaleType: 'custom'
                    };
                break;
            default:  // 'predefined' number : ensure number
                scaleOpts = {
                    scale: parseFloat(scale),
                    scaleType: scaleType
                }; //i think extra param 'scale' was typo
                break;
        }


        if ( options && options.byForce ) {

            // Don't set to null silently, then you mess up the the previous value;
            // Instead, set the actual values silently and trigger the associated
            // event calls in the order of Backbone's dispatcher.
            // Could make this standardized given still heavy usage of Backbone ...
            // Also good to know -- maybe implement something similar for other state
            // attributes with change events that we encounter issues with firing events twice. --
            // Eg: maybe intercept in 'api', set selectly, then fire events as needed ..

            this.set( scaleOpts, _.extend( {}, options, {
                silent: true
            }));

            this.trigger('change:scale', this, scaleOpts.scale, options );
            this.trigger('change:scaleType', this, scaleOpts.scaleType, options );

        } else {

            this.set(scaleOpts, options);

        }

    },

    // Old comment in here said to not round!
    getFitWidthScale: function(outerWt, pageW) {
        
        var availableWidth = outerWt - this.doubleHorPadding,
            scale = availableWidth / pageW;

         //Account for horizontal scroll if it would exceed the amount
        var projectedWidth = pageW * scale;
        if ( projectedWidth >= availableWidth - this.SB_W ) {
            availableWidth -= this.SB_W;
            scale = availableWidth / pageW;
        }

        return scale;

    },

    getFitHeightScale: function(outerHt, outerWt, pageH, pageW ) {
        
        var availableHt = outerHt - this.doubleVertPadding,
            availableWidthScale = availableHt / pageH, // need to see if scale change would cause the img wt to be > container causing horizontal overflow ( don't round! )
            projectedWidth = ( pageW * availableWidthScale ) + this.doubleHorPadding;

        return projectedWidth >= outerWt
            ? (availableHt - this.SB_W) / pageH
            : availableWidthScale;
    },

    getFriendlyScaleValue: function() { /* the value that is printed in the zoom input (and also that is selected in the drop down) */

        var type = this.get('scaleType');
        if (type === 'predefined' || type === 'custom') { //numeric
            return (this.get('scale') * 100).toFixed(0) + '%';
        } else { //non-numeric
            return type;  //the printed value is the scale type now, no need to XREF
        }

    },

    // only use internally
    _getScaleType: function() {
        var scale = this.get('scale');
        return isNaN(scale) ? scale : 'predefined';
    },

    getScaleValue: function() {
        return this.get('scale');
    },

    // Return in order most likely to be set in Document Mode, for performance
    scaledTypeIsDerived: function() {

        var scaleType = this.get('scaleType');

        return scaleType === 'Auto' ||
            scaleType === 'Fit Width' ||
            scaleType === 'Fit Height' ||
            scaleType === 'Best Fit';

    },

    isBestFit: function() {
        return this.get('scaleType') === 'Best Fit';
    },

    onDestroy: function() {

        this.off();

        // Could already have been removed if destroyed prior --
        var outerDiv = this.get('outerDiv');
        outerDiv && ( outerDiv = null );

        //this.clear({silent: true}); // would already have been deleted in doc mode view
    }

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/scale.js
 ** module id = 102
 ** module chunks = 0
 **/